import {
    GET_ALL_EQUIPMENT_PENDING,
    GET_ALL_EQUIPMENT_FULFILLED,
    GET_ALL_EQUIPMENT_REJECTED,
    GET_EQUIPMENT_ITEM_PENDING,
    GET_EQUIPMENT_ITEM_FULFILLED,
    GET_EQUIPMENT_ITEM_REJECTED,
    GET_EQUIPMENT_PENDING,
    GET_EQUIPMENT_FULFILLED,
    GET_EQUIPMENT_REJECTED,
    DELETE_EQUIPMENT_PENDING,
    DELETE_EQUIPMENT_FULFILLED,
    DELETE_EQUIPMENT_REJECTED,
    UPLOAD_EQUIPMENT_FULFILLED,
    UPLOAD_EQUIPMENT_PENDING,
    UPLOAD_EQUIPMENT_REJECTED,
    ADD_SEGMENT_TO_EQUIPMENT_PENDING,
    ADD_SEGMENT_TO_EQUIPMENT_FULFILLED,
    ADD_SEGMENT_TO_EQUIPMENT_REJECTED,
    REMOVE_SEGMENT_FROM_EQUIPMENT_PENDING,
    REMOVE_SEGMENT_FROM_EQUIPMENT_FULFILLED,
    REMOVE_SEGMENT_FROM_EQUIPMENT_REJECTED,
    ADD_TYPE_TO_EQUIPMENT_PENDING,
    ADD_TYPE_TO_EQUIPMENT_FULFILLED,
    ADD_TYPE_TO_EQUIPMENT_REJECTED,
    REMOVE_TYPE_FROM_EQUIPMENT_PENDING,
    REMOVE_TYPE_FROM_EQUIPMENT_FULFILLED,
    REMOVE_TYPE_FROM_EQUIPMENT_REJECTED,
    UPDATE_EQUIPMENT_ITEM_PENDING,
    UPDATE_EQUIPMENT_ITEM_FULFILLED,
    UPDATE_EQUIPMENT_ITEM_REJECTED
} from '../actions/EquipmentActions';

// INITIALIZE STATE
const initialState = {
    allEquipment: [],
    equipment: [],
    equipmentItem: {},
    fetchingAllEquipment: false,
    fetchedAllEquipment: false,
    failedAllEquipment: false,
    fetchingEquipmentItem: false,
    fetchedEquipmentItem: false,
    failedEquipmentItem: false,
    deleting: false,
    deleted: false,
    deleteFailed: false,
    uploadingEquipment: false,
    uploadedEquipment: false,
    uploadEquipmentFailed: false,
    fetchingEquipmentFromIds: false,
    fetchedEquipmentFromIds: false,
    failedEquipmentFromIds: false,
    addingSegmentToEquipment: false,
    addedSegmentToEquipment: false,
    addSegmentToEquipmentFailed: false,
    removingSegmentFromEquipment: false,
    removedSegmentFromEquipment: false,
    removeSegmentFromEquipmentFailed: false,
    addingTypeToEquipment: false,
    addedTypeToEquipment: false,
    addTypeToEquipmentFailed: false,
    removingTypeFromEquipment: false,
    removedTypeFromEquipment: false,
    removeTypeFromEquipmentFailed: false,
    updateEquipmentItemPending: false,
    updateEquipmentItemFulfilled: false,
    updateEquipmentItemRejected: false
};

export const EquipmentReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_ALL_EQUIPMENT_PENDING:
            return {
                ...state,
                fetchingAllEquipment: true,
                fetchedAllEquipment: false,
                failedAllEquipment: false
            };
        case GET_ALL_EQUIPMENT_FULFILLED:
            return {
                ...state,
                allEquipment: action.payload,
                fetchingAllEquipment: false,
                fetchedAllEquipment: true,
                failedAllEquipment: false,
            };
        case GET_ALL_EQUIPMENT_REJECTED:
            return {
                ...state,
                fetchingAllEquipment: false,
                fetchedAllEquipment: false,
                failedAllEquipment: true,
            };
        case GET_EQUIPMENT_PENDING:
            return {
                ...state,
                equipment: [],
                fetchingEquipmentFromIds: true,
                fetchedEquipmentFromIds: false,
                failedEquipmentFromIds: false
            };
        case GET_EQUIPMENT_FULFILLED:
            return {
                ...state,
                equipment: action.payload,
                fetchingEquipmentFromIds: false,
                fetchedEquipmentFromIds: true,
                failedEquipmentFromIds: false
            };
        case GET_EQUIPMENT_REJECTED:
            return {
                ...state,
                fetchingEquipmentFromIds: false,
                fetchedEquipmentFromIds: false,
                failedEquipmentFromIds: true
            };
        case GET_EQUIPMENT_ITEM_PENDING:
            return {
                ...state,
                equipmentItem: {},
                fetchingEquipmentItem: true,
                fetchedEquipmentItem: false,
                failedEquipmentItem: false
            };
        case GET_EQUIPMENT_ITEM_FULFILLED:
            return {
                ...state,
                equipmentItem: action.payload,
                fetchingEquipmentItem: false,
                fetchedEquipmentItem: true,
                failedEquipmentItem: false
            };
        case GET_EQUIPMENT_ITEM_REJECTED:
            return {
                ...state,
                fetchingEquipmentItem: false,
                fetchedEquipmentItem: false,
                failedEquipmentItem: true
            };
        case DELETE_EQUIPMENT_PENDING:
            return {
                ...state,
                deleting: true,
                deleted: false,
                deleteFailed: false
            };
        case DELETE_EQUIPMENT_FULFILLED: {
            let allEquipment = state.equipment.filter(item => item.id !== action.payload);
            return {
                ...state,
                equipment: allEquipment,
                deleting: false,
                deleted: true,
                deleteFailed: false
            };
        }
        case DELETE_EQUIPMENT_REJECTED:
            return {
                ...state,
                deleting: false,
                deleted: false,
                deleteFailed: true,
            };
        case UPLOAD_EQUIPMENT_PENDING:
            return {
                ...state,
                uploadingEquipment: true,
                uploadedEquipment: false,
                uploadEquipmentFailed: false,
            };
        case UPLOAD_EQUIPMENT_FULFILLED:
            return {
                ...state,
                uploadedEquipment: true,
                uploadingEquipment: false,
                uploadEquipmentFailed: false
            };
        case UPLOAD_EQUIPMENT_REJECTED:
            return {
                ...state,
                uploadedEquipment: false,
                uploadingEquipment: false,
                uploadEquipmentFailed: true
            };
        case ADD_SEGMENT_TO_EQUIPMENT_PENDING:
            return {
                ...state,
                addingSegmentToEquipment: true,
                addedSegmentToEquipment: false,
                addSegmentToEquipmentFailed: false
            };
        case ADD_SEGMENT_TO_EQUIPMENT_FULFILLED: {
            let equipment = JSON.parse(JSON.stringify(state.equipmentItem));
            if(equipment != {}){
                for(let segmentID of action.payload.segmentIds){
                    if (equipment.segments == undefined || equipment.segments == null) {
                        equipment['segments'] = {};
                        equipment.segments[segmentID] = true;
                    } else {
                        equipment.segments[segmentID] = true;
                    }
                }
            }
            return {
                ...state,
                equipmentItem: equipment,
                addingSegmentToEquipment: false,
                addedSegmentToEquipment: true,
                addSegmentToEquipmentFailed: false
            };
        }
        case ADD_SEGMENT_TO_EQUIPMENT_REJECTED:
            return {
                ...state,
                addingSegmentToEquipment: false,
                addedSegmentToEquipment: false,
                addSegmentToEquipmentFailed: true
            };
        case REMOVE_SEGMENT_FROM_EQUIPMENT_PENDING:
            return {
                ...state,
                removingSegmentFromEquipment: true,
                removedSegmentFromEquipment: false,
                removeSegmentFromEquipmentFailed: false
            };
        case REMOVE_SEGMENT_FROM_EQUIPMENT_FULFILLED: {
            let equipment = state.equipment.filter(function (i) {
                return i.id !== action.payload.equipmentId;
            });
            return {
                ...state,
                equipment: equipment,
                removingSegmentFromEquipment: false,
                removedSegmentFromEquipment: true,
                removeSegmentFromEquipmentFailed: false
            };
        }
        case REMOVE_SEGMENT_FROM_EQUIPMENT_REJECTED:
            return {
                ...state,
                removingSegmentFromEquipment: true,
                removedSegmentFromEquipment: false,
                removeSegmentFromEquipmentFailed: true
            };
        case ADD_TYPE_TO_EQUIPMENT_PENDING:
            return {
                ...state,
                addingTypeToEquipment: true,
                addedTypeToEquipment: false,
                addTypeToEquipmentFailed: false
            };
        case ADD_TYPE_TO_EQUIPMENT_FULFILLED: {
            let equipment = JSON.parse(JSON.stringify(state.equipmentItem));
            if(equipment != {}){
                for(let type of action.payload.typeIDs){
                    if (equipment.productTypes == undefined || equipment.productTypes == null) {
                        equipment.productTypes = {};
                        equipment.productTypes[type] = true;
                    } else {
                        equipment.productTypes[type] = true;
                    }
                }
            }
            return {
                ...state,
                equipmentItem: equipment,
                addingTypeToEquipment: false,
                addedTypeToEquipment: true,
                addTypeToEquipmentFailed: false
            };
        } 
        case ADD_TYPE_TO_EQUIPMENT_REJECTED:
            return {
                ...state,
                addingTypeToEquipment: false,
                addedTypeToEquipment: false,
                addTypeToEquipmentFailed: true
            };
        case REMOVE_TYPE_FROM_EQUIPMENT_PENDING:
            return {
                ...state,
                removingTypeFromEquipment: true,
                removedTypeFromEquipment: false,
                removeTypeFromEquipmentFailed: false
            };
        case REMOVE_TYPE_FROM_EQUIPMENT_FULFILLED: {
            
            let equipmentItem = JSON.parse(JSON.stringify(state.equipmentItem));
            if(equipmentItem != {}){
                delete equipmentItem.productTypes[action.payload.typeID];
            }
            return {
                ...state,
                equipmentItem: equipmentItem,
                removingTypeFromEquipment: false,
                removedTypeFromEquipment: true,
                removeTypeFromEquipmentFailed: false
            };
        }  
        case REMOVE_TYPE_FROM_EQUIPMENT_REJECTED:
            return {
                ...state,
                removingTypeFromEquipment: false,
                removedTypeFromEquipment: true,
                removeTypeFromEquipmentFailed: false
            };

        case UPDATE_EQUIPMENT_ITEM_PENDING:
            return {
                ...state,
                updateEquipmentItemPending: true,
                updateEquipmentItemFulfilled: false,
                updateEquipmentItemRejected: false
            };
        case UPDATE_EQUIPMENT_ITEM_FULFILLED:
            return {
                ...state,
                equipmentItem: action.payload,
                updateEquipmentItemPending: false,
                updateEquipmentItemFulfilled: true,
                updateEquipmentItemRejected: false
            };
        case UPDATE_EQUIPMENT_ITEM_REJECTED:
            return {
                ...state,
                updateEquipmentItemPending: false,
                updateEquipmentItemFulfilled: false,
                updateEquipmentItemRejected: true
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/state/reducers/EquipmentReducer.js